export default function () {
    this.loadData()
}
